import type { ReassignmentFormData } from './generated/v1/types.gen'

/**
 * User-facing labels for the v1 reassignment reason enum.
 *
 * Typed against `ReassignmentFormData['reasons'][number]` so adding a new
 * reason to the OpenAPI spec without a matching label fails the build.
 */
type ReassignmentReason = ReassignmentFormData['reasons'][number]

export const REASSIGNMENT_REASON_LABELS: Record<ReassignmentReason, string> = {
  conflict_of_interest: 'Conflict of Interest',
  scheduling_error: 'Scheduling Error / Conflict',
  clinician_family_availability: 'Clinician / Family Availability',
  clinician_resignation: 'Clinician Resignation',
  leave_of_absence: 'Leave of Absence or Pause',
  reassignment_due_to_cm: 'Reassignment due to CM request',
  other: 'Other',
}
